// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "font-awesome/css/font-awesome.css";
import App from "./App";
import router from "./router";
import VueNativeSock from "vue-native-websocket";
import store from "./store";
import moment from "moment";
import "./assets/iconfont/iconfont.css";
import VueClipboard from "vue-clipboard2";
import arms from "@/utils/arms";
import { wsUrl } from "@/config/env";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import VueSimpleContextMenu from "vue-simple-context-menu";
import filters from "./filters";
import VueWindowSize from "vue-window-size";
import { getImToken } from "@/utils/cookies";
import i18n from "./i18n/config";

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.use(Viewer);
Viewer.setDefaults({
	url: "data-original",
	title: false,
	navbar: false,
	play: false,
	toolbar: {
		zoomIn: 1,
		zoomOut: 1,
		oneToOne: 1,
		reset: 1,
		prev: true,
		play: 0,
		next: true,
		rotateLeft: 1,
		rotateRight: 1,
		flipHorizontal: 1,
		flipVertical: 1,
	},
});

Vue.use(VueClipboard);

moment.locale("zh-cn");

// WebSocket连接
Vue.use(VueNativeSock, wsUrl + "?token=" + getImToken(), {
	connectManually: true, // 手动连接
	store: store, // 状态仓库
	reconnection: true, //是否自动重连
	reconnectionAttempts: 100000, // 尝试重连的次数
	reconnectionDelay: 3000, // 重连频率
});

Vue.config.errorHandler = (err, vm, info) => {
	arms.error(err, { filename: `${vm.$vnode.tag}, ${info}` });
};

Vue.use(filters);

Vue.use(VueWindowSize);

Vue.component("vue-simple-context-menu", VueSimpleContextMenu);

new Vue({
	el: "#app",
	i18n,
	router,
	store,
	components: {
		App,
	},
	template: "<App/>",
});
